import React, { useState } from 'react'
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField } from '@mui/material'
import api from '../../services/api'
import useAuth from '../../hooks/useAuth'
import { canCreateProduct } from './productPermissions'

const ProductCreateDialog = ({ onClose, onCreated }) => {
  const { user } = useAuth()
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [price, setPrice] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')
  const [contextClientId] = useState(user?.clientId)
  const permitted = canCreateProduct(user) && String(user?.clientId) === String(contextClientId)

  const submit = async (event) => {
    event.preventDefault()
    if (saving || !permitted) return
    if (!name.trim() || (price !== '' && !/^\d{1,8}(\.\d{1,2})?$/.test(price))) {
      setError('Indica un nombre y un precio válido con hasta dos decimales.')
      return
    }
    setSaving(true)
    setError('')
    try {
      // No clientId/userId from the form: POST derives both from the session.
      const response = await api.post('/products', {
        name_product: name.trim(), description: description.trim(), price: price === '' ? null : price,
      })
      if (response.status !== 201 || !response.data?.id) {
        setError('No fue posible confirmar el resultado. Recarga el listado antes de reintentar.')
        return
      }
      onCreated()
    } catch (_error) {
      setError('No fue posible confirmar el guardado. Revisa la sesión y recarga el listado antes de reintentar.')
    } finally {
      setSaving(false)
    }
  }

  return (
    <Dialog open onClose={saving ? undefined : onClose} fullWidth maxWidth="sm" aria-labelledby="create-product-title">
      <form onSubmit={submit}>
        <DialogTitle id="create-product-title">Crear producto</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 1 }}>
            <Alert severity="info">El producto se guardará en el cliente de la sesión actual (ID: {String(contextClientId)}). Un nombre existente puede devolver el producto anterior.</Alert>
            {!permitted && <Alert severity="warning">El contexto cambió o no permite crear. Cierra y vuelve a abrir el formulario.</Alert>}
            {error && <Alert severity="error">{error}</Alert>}
            <TextField autoFocus required label="Nombre" value={name} onChange={(event) => setName(event.target.value)} disabled={saving || !permitted} inputProps={{ maxLength: 255 }} />
            <TextField label="Descripción" multiline value={description} onChange={(event) => setDescription(event.target.value)} disabled={saving || !permitted} />
            <TextField label="Precio" value={price} onChange={(event) => setPrice(event.target.value)} disabled={saving || !permitted} inputProps={{ inputMode: 'decimal' }} helperText="Opcional; usa punto decimal." />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={saving}>Cancelar</Button>
          <Button type="submit" disabled={saving || !permitted} variant="contained">{saving ? 'Guardando…' : 'Guardar'}</Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}
export default ProductCreateDialog
